import styles from './styles.module.scss';

const MoreMenu = ({ children }) => {
  return <div className={styles.moreMenu}>{children}</div>;
};

export default MoreMenu;
